export default {
	cihangban: 'Penerbangan ini',
	paifangliang: 'Emisi dihitung untuk 1 penumpang di kelas tempat duduk pilihan Anda',
	chengke: 'Penumpang',
	quebaoziliaozhengque: 'Harap pastikan semua informasi sudah benar',
	ruhetianxiechengke: 'bagaimana cara mengisi detail penumpang?',
	beizhu: 'Keterangan',
	piaohao: 'Nomor Tiket',
	chakanpiaojiaguize: 'Lihat aturan tarif',
	shengyushijian: 'X menit tersisa untuk menyelesaikan pemesanan ini.',
	zongjie: 'Ringkasan',
	shuifeifujia: 'Pajak & Biaya lainnya',
	zonge: 'Jumlah',
	xingbie: 'Jenis kelamin',
	nan: 'Pria',
	nv: 'Wanita',
	xingshi: 'Nama Belakang',
	zhongjianming: 'Nama Tengah',
	mingzi: 'Nama Depan',
	lizi0: 'Contoh:LEE',
	ruyou: 'Jika ada',
	lizi: 'Contoh:SIU MENG',
	zhengjianleixing: 'Jenis Dokumen',
	qingxuanze: 'Silahkan Pilih',
	huzhaohaoma: ' Nomor Paspor',
	huzhao: 'Paspor',
	qingshuru: 'Silahkan Tekan ',
	huzhaoguojia: 'Negara Asal dokumen',
	daoqiriqi: 'Tarikh skadasi paspor',
	chushengriqi: 'Tanggal lahir',
	shifouchangke: 'Tambahkan Nomor Program frequent flyer?',
	lianluoren: 'Informasi Kontak',
	dianyoudizhi: ' Alamat email',
	zhengquedianyoudizhi: 'Alamat email benar',
	lianluodianhua: ' Nomor telepon',
	qingshurudianhua: 'Nomor Ponsel',
	guojia: 'Negara',
	wanchengyuding: 'Selesaikan pemesanan anda',
	wancheng: 'Selesai',
	fukuanxijie: 'Rincian Pembayaran',
	shuikuanfujiafei: 'Termasuk Pajak & Biaya lainnya',
	woyiyueduotiaokuan: 'Saya telah membaca dan menyetujui Syarat dan Ketentuan.',
	woyiyueduo: 'Saya telah membaca dan menyetujui Syarat dan Ketentuan.',
	baocunxiangxixinxi: 'Simpan detail di sini untuk melengkapi formulir secara otomatis untuk pemesanan penerbangan di masa mendatang.',
	xiayibu: 'Lanjutkan',
	fanhui: 'Kembali',
	baocun: 'Simpan',
	xuanzezuowei: 'silakan pilih kursi',
	ewaituibu: 'Ruang kaki tambahan',
	shouxuan: 'Diutamakan',
	biaozhun: 'Standar',
	queren: 'Konfirmasi',
	chongzhi: 'Mengatur ulang',
	quxiao: 'Batal',
	yixuan: 'Terisi',
	shangwu: 'Bisnis',
	jingji: 'Ekonomi',
	meiyouxuanwei: 'Tidak ada kursi yang dipilih',
	xuanzezhong: 'Terpilih',
	xiagehangban: 'Penerbangan Selanjutnya',
	chuangjiandingdan: 'Pesan sekarang',
	chengkeanzhengjian:
		'Semua nama penumpang (Tn/Nn/Ny) harus sesuai dengan yang tertera pada KTP, Paspor atau dokumen perjalanan lain yang sah. Perubahan pada nama Penumpang tidak diperbolehkan setelah transaksi berhasil diselesaikan.',
	shurudianziyoujian: 'Menerima Konfirmasi Reservasi & Tanda Terima Tiket.',
	hangbanbiangengshouyueshu:
		'Jadwal penerbangan sewaktu-waktu dapat berubah sesuai pada Syarat & Ketentuan maskapai terkait.',
	yudingzhongguanli: 'Anda masih dapat merubah* dan/atau mengatur pemesanan anda di “Pesanan Saya”. Namun, perlu diketahui bahwa setiap perubahan pada Pemesanan yang terkonfirmasi akan dikenakan biaya perubahan, melebihi pembayaran yang dikenakan untuk pembelian lama atau pembelian baru yang dilakukan.',
	cuxiaopiaojiabu: 'Tidak ada Perubahan yang diizinkan untuk tarif Promosi.',
	chakanlvxingjianyi:
		'- Silakan periksa anjuran Perjalanan dan Syarat & Ketentuan barang bawaan di Rencana Perjalanan Anda untuk perubahan yang diperbolehkan.'

};
